import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Seo from "../components/Seo";
import Hero from "../components/Hero";
import LandingPage from "../components/LandingPage";
import Main from "../components/Main/";
import Header from "../components/Header/";
import Footer from "../components/Footer/";

class Index extends React.Component {
  state = {
    separators: []
  };

  componentDidMount() {
    if (this.props.data.pages.edges) {
      const seps = this.props.data.pages.edges.map(() => React.createRef());
      seps.push(React.createRef());
      seps.push(React.createRef());
      this.setState({ separators: seps });
    }
  }

  scrollToContent = index => {
    this.state.separators[index].current.scrollIntoView({ block: "start", behavior: "smooth" });
  };

  render() {
    const { data } = this.props;
    const facebook = (((data || {}).site || {}).siteMetadata || {}).facebook;
    const {
      data: {
        bgDesktop: {
          resize: { src: desktop }
        },
        bgTablet: {
          resize: { src: tablet }
        },
        bgMobile: {
          resize: { src: mobile }
        }
      }
    } = this.props;

    const backgrounds = {
      desktop,
      tablet,
      mobile
    };

    const {
      pages: { edges: pages }
      /*posts: { edges: posts }*/
    } = data;

    const posts = [];

    return (
      <React.Fragment>
        <Main>
          <Header
            path={this.props.location.pathname}
            pages={pages}
            isWideScreen={this.props.isWideScreen}
            scrollToContent={this.scrollToContent}
          />
          <Hero
            backgrounds={backgrounds}
            separators={this.state.separators}
            scrollToContent={this.scrollToContent}
          />
          <LandingPage
            sections={data.pages.edges}
            separators={this.state.separators}
            posts={posts}
          />
          <Footer footnote={data.footnote} />
          <Seo facebook={facebook} />
        </Main>
      </React.Fragment>
    );
  }
}

Index.propTypes = {
  data: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  isWideScreen: PropTypes.bool.isRequired
};

const mapStateToProps = (state, ownProps) => {
  return {
    navigatorPosition: state.navigatorPosition,
    isWideScreen: state.isWideScreen
  };
};

export default connect(mapStateToProps)(Index);

//eslint-disable-next-line no-undef
export const pageQuery = graphql`
  query IndexQuery {
    site {
      siteMetadata {
        facebook {
          appId
        }
      }
    }
    pages: allMarkdownRemark(
      filter: { id: { regex: "//pages//" }, fields: { prefix: { regex: "/^\\d+$/" } } }
      sort: { fields: [fields___prefix], order: ASC }
    ) {
      edges {
        node {
          html
          fields {
            slug
            prefix
          }
          frontmatter {
            title
            menuTitle
          }
        }
      }
    }
    footnote: markdownRemark(id: { regex: "/footnote/" }) {
      id
      html
    }
    bgDesktop: imageSharp(id: { regex: "/hero-background/" }) {
      resize(width: 1200, quality: 90, cropFocus: CENTER) {
        src
      }
    }
    bgTablet: imageSharp(id: { regex: "/hero-background/" }) {
      resize(width: 800, height: 1100, quality: 90, cropFocus: CENTER) {
        src
      }
    }
    bgMobile: imageSharp(id: { regex: "/hero-background/" }) {
      resize(width: 450, height: 850, quality: 90, cropFocus: CENTER) {
        src
      }
    }
  }
`;
/*
posts: allMarkdownRemark(
      limit: 4
      filter: { id: { regex: "//posts//" } }
      sort: { fields: [fields___prefix], order: DESC }
    ) {
      edges {
        node {
          excerpt
          fields {
            slug
            prefix
          }
          frontmatter {
            title
            subTitle
            category
            cover {
              children {
                ... on ImageSharp {
                  resolutions(width: 90, height: 90) {
                    ...GatsbyImageSharpResolutions_withWebp_noBase64
                  }
                }
              }
            }
          }
        }
      }
    }
    */



// WEBPACK FOOTER //
// ./src/pages/index.js